import { dialogDefault, DIALOG_CATALOG } from "../consts";

const mydialog = { ...dialogDefault }

export const dialogCatalog =  catalog => ({ type: DIALOG_CATALOG, payload : catalog });

export default function catalogDialogReducer(state = mydialog, { type, payload }) {
   
    const actions = {
        [DIALOG_CATALOG] : () => ({...payload })
    }

    return actions[type]?.call() || state;
}